define('util/javaInteropConstants',{
    JAVA_MAX_INT: 2147483647,
    JAVA_MIN_INT: -2147483648
});
